"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultHeaders = {};
var RequestContext = react_1.createContext(defaultHeaders);
exports.RequestContext = RequestContext;
var RequestProvider = function (_a) {
    var _b = _a.headers, headers = _b === void 0 ? defaultHeaders : _b, children = _a.children;
    return react_1.createElement(RequestContext.Provider, { value: headers }, children);
};
exports.default = RequestProvider;
